/**
 * My account menu items can be a/b tested now by updating exiting menu items to new ones
 * or adding a new menu items at a given location in the dropdown menu
 *
 * AB tests' response should follow the following format. it should be an array of menu items
 *
 * if updating an exiting menu item, labelB, the new label, will replace labelA, which is the current label.
 * "insertOrUpdate" and "href" properties are optional in this case.
 *
 * if inserting a new menu item , labelA is the menu item above the new menu item and it is used
 * to indicate the position of the new menu item. The new menu item will be inserted below labelA
 * "insertOrUpdate" and "href" properties are not optional.
 *
 *
 [
   {
      label: "Name of the Nav",
      menuItems: [
        {
          labelA: "Current label",
          labelB: "New label",
          insertOrUpdate: "update"
          href: "/my-account/link"
        }
      ]
    },

   {
      label: "Name of the Nav",
      menuItems: [
        {
          labelA: "Current label",
          labelB: "New label",
          insertOrUpdate: "insert"
          href: "/my-account/link"
        }
      ]
    }
 ]
 *
 */

/**
 * IMPORTANT: Make sure to remove mboxes once the AB test period is over. Just after you add a mbox to the following
 * object, please a raise a JIRA ticket and assign it to yourself as a reminder to clean up
 */
export const P21_980_MY_ACCOUNT_NAV_MBOX = "P21-980-mbox";

export const OE_234_MBOX = "OE-234-mbox";

export const TON_2065_MBOX = "TON-2065-mbox";

export const P21_1084_MBOX = "P21-1084-mbox";

export const mboxes = [
  P21_980_MY_ACCOUNT_NAV_MBOX,
  OE_234_MBOX,
  TON_2065_MBOX,
  P21_1084_MBOX,
];
